import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-zinc-900 border-y border-amber-900/40" data-id="element-109">
      <div className="container mx-auto px-4 text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-black/80 rounded-3xl p-8 md:p-12 shadow-2xl border border-amber-500/40" data-id="element-111">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-500/20 text-amber-300 mb-6 border border-amber-500/40" data-id="element-112">
            <ShieldCheck className="w-10 h-10" data-id="element-113" />
          </div>

          <h2 className="text-3xl font-extrabold text-white mb-4" data-id="element-114">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-zinc-200 mb-6" data-id="element-115">
            Abrís los módulos. Los aplicás en tu taller. Si en 7 días no es lo
            que esperabas:
          </p>

          <div className="bg-amber-500/15 text-amber-200 font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-amber-500/40" data-id="element-116">
            Devolución del 100% sin formularios, sin drama.
          </div>

          <p className="text-sm text-amber-300 font-medium uppercase tracking-wider" data-id="element-117">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}